var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isGrupoFamiliar
    ? _c("div", { staticClass: "footer" }, [
        _c(
          "footer",
          [
            _vm._m(0),
            _c("v-divider", { staticStyle: { color: "white" } }),
            _c("div", { staticClass: "footer-container" }, [
              _vm._m(1),
              _c("div", { staticClass: "address" }),
              _c("ul", [
                _c(
                  "li",
                  [
                    _c("router-link", { attrs: { to: "/terminos" } }, [
                      _vm._v("Términos y condiciones"),
                    ]),
                  ],
                  1
                ),
                _c(
                  "li",
                  [
                    _c("router-link", { attrs: { to: "/nosotros" } }, [
                      _vm._v("Sobre nosotros"),
                    ]),
                  ],
                  1
                ),
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      { attrs: { to: "/politicasprivacidad" } },
                      [_vm._v("Políticas de privacidad")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ],
          1
        ),
        _vm._m(2),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "container-logo-faq" }, [
      _c("img", {
        staticClass: "logo",
        attrs: {
          src: require("../assets/logo_conecta_blanco.svg"),
          alt: "Logo Conecta",
          width: "400",
          height: "55",
          decoding: "async",
          loading: "lazy",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "address" }, [
      _c("p", [
        _vm._v(
          "Superintendencia de Servicios de Salud - 0800 - 222 - 72583 (SALUD) - www.sssalud.gob.ar - R.N.E.M.P.(Prov.) 1297 "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "container-filation" }, [
      _c("img", {
        staticClass: "filiation-logo",
        attrs: {
          src: require("../assets/FiliationLogo.svg"),
          alt: "Filiation",
          width: "138",
          height: "20",
          decoding: "async",
          loading: "lazy",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }